import './header.scss';

import { Menu, MenuButton, MenuDivider, MenuHeader, MenuItem, MenuRadioGroup, SubMenu } from '@szhsin/react-menu';
import { React, useState } from 'react';

import MenuDropdown from '../menu/menu';
import { SketchPicker } from 'react-color'
import Uploader from '../uploader/uploader';

const Header = () => {
  const [color, changeColor] = useState('#e78d06');
  const [textColor, changeTextColor] = useState('#292929');

  const updateColor = (color) => {
    changeColor(color.hex);
    console.log('color', color);
    document.documentElement.style.setProperty(
      '--color-kt',
      color.hex
    );

    document.documentElement.style.setProperty(
      '--background-color',
      `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.a}, 0.3)`
    );
  }

  const updateTextColor = (color) => {
    changeTextColor(color.hex);
    document.documentElement.style.setProperty(
      '--text-color',
      color.hex
    );
  }

  return (
    <div className="header no-print" id="aheader">
      <span className="title">KT Card Generator</span>
      <Uploader />

      <div className="options">
        <MenuDropdown />
        <Menu menuButton={<MenuButton className="color-button"><div className="color-picker-swatch" style={{ backgroundColor: color }}></div></MenuButton>}
          onItemClick={(e) => e.keepOpen = true}
          transition
          key="bottom"
          align="end">
            <SubMenu label="Text Color">
              <MenuItem>
                <SketchPicker
                  onChange={updateTextColor}
                  color={textColor}
                  presetColors={[]}
                  disableAlpha={true} />
              </MenuItem>
            </SubMenu>
            <SubMenu label="Card Color">
              <MenuItem>
                <SketchPicker
                  onChange={updateColor}
                  color={color}
                  presetColors={[]}
                  disableAlpha={true} />
              </MenuItem>
            </SubMenu>
        </Menu>
      </div>
    </div>
  );
};

export default Header;
